import {
    TableRenderer,
    TableRenderType
} from "../../shared/components/edit-table/table-renderer";

import {
    JsonItem
} from "../../shared/entities/pick-list/pick-list.entities";

import {
    getDisplayDate
} from "../../shared/scripts/date-functions";
import { CabHubConnectionEditController, CabHubConnectionFormController } from "./cab-hub-tracking.controller";

import {
    CabHubCompletedSurveyRow, CabHubConnectionEntity
} from "./cab-hub-tracking.entities";


export type CabHubConnectionDetailsVm = {
    Id:
    number;

    Status:
    string;

    DocumentUploadId:
    string;

    SurveyHistory:
    CabHubCompletedSurveyRow[];

    PickLists:
    JsonItem[];
    Connection:
    CabHubConnectionEntity;
    Scope: string;
};


export class CabHubConnectionDetailsPage {

    private readonly surveyHistoryTable:
        CabHubConnectionSurveyHistoryTable;
    private readonly connectionForm:
        CabHubConnectionFormController;

    private readonly connectionEdit:
        CabHubConnectionEditController;

    constructor(
        private readonly vm:
            CabHubConnectionDetailsVm
    ) {
        this.surveyHistoryTable =
            new CabHubConnectionSurveyHistoryTable(
                this.vm.SurveyHistory ?? [],
                this.vm.PickLists ?? []
            );
        this.connectionForm = new CabHubConnectionFormController(
            this.vm as any,
            "/secure/cab-hub/cab-hub-tracking"
        );
        this.connectionForm
            .initialize();

        this.connectionEdit =
            new CabHubConnectionEditController(
                this.connectionForm
            );

        this.initializeStatus();

        this.initializeAgreementDownload();
        $("#edit-connection-button")
            .on(
                "click",
                () => {

                    this.connectionEdit
                        .openConnection(
                            this.vm.Connection
                        );
                }
            );

        this.surveyHistoryTable
            .initialize();
    }


    private initializeStatus():
        void {

        const isActive =
            (this.vm.Status ?? "")
                .trim()
                .toLowerCase() ===
            "active";

        $("#cab-hub-connection-status")
            .addClass(
                isActive
                    ? "cab-edit-table-active-pill"
                    : "cab-detail-table-inactive-pill"
            );
    }


    private async initializeAgreementDownload():
        Promise<void> {

        const uploadId =
            this.vm.DocumentUploadId;

        if (!uploadId) {
            return;
        }

        try {
            const result: any =
                await $.ajax(
                    "/api/upload-service/get-files",
                    {
                        method:
                            "POST",

                        headers: {
                            "RequestVerificationToken":
                                String(
                                    $(
                                        'input[name="__RequestVerificationToken"]'
                                    ).val() ?? ""
                                )
                        },

                        contentType:
                            "application/json; charset=utf-8",

                        data:
                            JSON.stringify({
                                rootFolderPath:
                                    "cab-hub-uploads",

                                uuidArray: [
                                    uploadId
                                ]
                            })
                    }
                );

            const document =
                result?.items?.[0];

            if (!document) {
                $("#cab-hub-agreement-loading")
                    .text(
                        "Agreement document unavailable"
                    );

                return;
            }

            const filePath =
                encodeURI(
                    document.id
                );

            $("#cab-hub-agreement-download")
                .attr(
                    "href",
                    `/api/upload-service/download-file?filePath=${filePath}`
                )
                .attr(
                    "download",
                    document.text
                )
                .text(
                    document.text ||
                    "View agreement document"
                )
                .removeClass(
                    "d-none"
                );

            $("#cab-hub-agreement-loading")
                .remove();
        }
        catch (error) {
            console.error(
                "Unable to load agreement document:",
                error
            );

            $("#cab-hub-agreement-loading")
                .text(
                    "Agreement document unavailable"
                );
        }
    }
}


export class CabHubConnectionSurveyHistoryTable {

    private readonly tableId =
        "connection-survey-history-table";

    private dataTable:
        any;

    private readonly tableRenderer:
        TableRenderer;


    constructor(
        private readonly rows:
            CabHubCompletedSurveyRow[],

        private readonly pickLists:
            JsonItem[]
    ) {
        this.tableRenderer =
            new TableRenderer(
                this.pickLists
            );
    }


    public initialize():
        void {

        $(`#${this.tableId}`)
            .on(
                "click",
                ".js-view-completed-survey",
                e => {

                    const surveyId =
                        Number(
                            $(e.currentTarget)
                                .data(
                                    "survey-id"
                                )
                        );

                    const surveyType =
                        String(
                            $(e.currentTarget)
                                .data(
                                    "survey-type"
                                )
                        );

                    const survey =
                        this.rows
                            .find(
                                row =>
                                    row.SurveyId ===
                                    surveyId &&
                                    row.SurveyType ===
                                    surveyType
                            );

                    if (!survey) {
                        return;
                    }

                    this.openCompletedSurvey(
                        survey
                    );
                }
            );


        this.dataTable =
            $(`#${this.tableId}`)
                .DataTable({
                    data:
                        this.rows,

                    paging:
                        false,

                    searching:
                        true,

                    info:
                        false,

                    ordering:
                        true,

                    scrollX:
                        true,

                    scrollCollapse:
                        true,

                    scrollY:
                        "60vh",

                    autoWidth:
                        true,

                    dom:
                        '<"connection-survey-history-controls d-flex align-items-center justify-content-between mb-2"fB>rt',

                    buttons: [
                        {
                            extend:
                                "csv",

                            text:
                                '<i class="fas fa-file-download"></i>',

                            titleAttr:
                                "CSV",

                            charset:
                                "utf-8",

                            exportOptions: {
                                columns:
                                    ":not(.no-export)"
                            }
                        }
                    ],

                    language: {
                        emptyTable:
                            "No surveys have been submitted for this connection."
                    },

                    columns: [
                        {
                            data:
                                "SurveyType",

                            title:
                                "Survey Type",

                            className:
                                "text-left font-size12 nowrap"
                        },
                        {
                            data:
                                null,

                            title:
                                "Month / Year",

                            className:
                                "text-left font-size12 nowrap",

                            render:
                                (
                                    row:
                                        CabHubCompletedSurveyRow,
                                    type:
                                        string
                                ): string => {

                                    const display =
                                        this.getReportingPeriod(
                                            row
                                        );

                                    return type ===
                                        "display"
                                        ? display
                                        : `${row.ReportingYear}-${row.ReportingMonth}`;
                                }
                        },
                        {
                            data:
                                "HubShortName",

                            title:
                                "Hub",

                            className:
                                "text-left font-size12 nowrap"
                        },
                        {
                            data:
                                "CabMemberName",

                            title:
                                "CAB Member",

                            className:
                                "text-left font-size12 nowrap"
                        },
                        {
                            data:
                                "MetThisMonth",

                            title:
                                "Met This Month",

                            className:
                                "text-center font-size12 nowrap",

                            render:
                                (
                                    value:
                                        boolean,
                                    type:
                                        string
                                ): string => {

                                    const text =
                                        value
                                            ? "Yes"
                                            : "No";

                                    if (
                                        type !==
                                        "display"
                                    ) {
                                        return text;
                                    }

                                    return `
                                        <span class="
                                            ${value
                                            ? "cab-edit-table-active-pill"
                                            : "cab-detail-table-inactive-pill"}
                                        ">
                                            ${text}
                                        </span>
                                    `;
                                }
                        },
                        {
                            data:
                                "SatisfactionRatingId",

                            title:
                                "Satisfaction",

                            className:
                                "text-left font-size12 nowrap",

                            render:
                                (
                                    value:
                                        number
                                ): string => {

                                    if (!value) {
                                        return "—";
                                    }

                                    return this.tableRenderer
                                        .renderDisplay(
                                            value,
                                            TableRenderType.Number,
                                            "SatisfactionRating"
                                        );
                                }
                        },
                        {
                            data:
                                "SupportRequested",

                            title:
                                "Support Requested",

                            className:
                                "text-center font-size12 nowrap",

                            render:
                                (
                                    value:
                                        boolean,
                                    type:
                                        string
                                ): string => {

                                    const text =
                                        value
                                            ? "Yes"
                                            : "No";

                                    if (
                                        type !==
                                        "display"
                                    ) {
                                        return text;
                                    }

                                    return `
                                        <span class="
                                            ${value
                                            ? "cab-edit-table-active-pill"
                                            : "cab-detail-table-inactive-pill"}
                                        ">
                                            ${text}
                                        </span>
                                    `;
                                }
                        },
                        {
                            data:
                                "SubmittedDate",

                            title:
                                "Submitted",

                            className:
                                "text-left font-size12 nowrap",

                            render:
                                (
                                    value:
                                        string,
                                    type:
                                        string
                                ): string => {

                                    if (!value) {
                                        return "";
                                    }

                                    return type ===
                                        "display"
                                        ? getDisplayDate(
                                            new Date(
                                                value
                                            )
                                        )
                                        : value;
                                }
                        },
                        {
                            data:
                                "SurveyId",

                            title:
                                "View",

                            className:
                                "text-center font-size12 nowrap no-export",

                            orderable:
                                false,

                            render:
                                (
                                    value:
                                        number,
                                    type:
                                        string,
                                    row:
                                        CabHubCompletedSurveyRow
                                ): string => {

                                    if (
                                        type !==
                                        "display"
                                    ) {
                                        return `${value ?? ""}`;
                                    }

                                    return `
                                        <button type="button"
                                                class="btn btn-sm font-size14 js-view-completed-survey"
                                                data-survey-id="${value}"
                                                data-survey-type="${row.SurveyType}">
                                            View
                                        </button>
                                    `;
                                }
                        }
                    ],

                    order: [
                        [
                            7,
                            "desc"
                        ]
                    ]
                });
    }


    private getReportingPeriod(
        row:
            CabHubCompletedSurveyRow
    ): string {

        return new Date(
            row.ReportingYear,
            row.ReportingMonth - 1,
            1
        )
            .toLocaleDateString(
                "en-US",
                {
                    month:
                        "long",

                    year:
                        "numeric"
                }
            );
    }


    private formatSurveyValue(
        value:
            any
    ): string {

        if (
            value === null ||
            value === undefined ||
            value === ""
        ) {
            return "—";
        }

        return String(
            value
        );
    }


    private renderSurveyPill(
        value:
            string
    ): string {

        const normalizedValue =
            (value ?? "")
                .trim()
                .toLowerCase();

        let pillClass =
            "cab-view-table-inactive-pill";

        if (
            normalizedValue ===
            "yes" ||
            normalizedValue ===
            "satisfied" ||
            normalizedValue ===
            "extremely satisfied"
        ) {
            pillClass =
                "cab-edit-table-active-pill";
        }
        else if (
            normalizedValue ===
            "not sure" ||
            normalizedValue ===
            "neither satisfied or dissatisfied"
        ) {
            pillClass =
                "cab-detail-table-neutral-pill";
        }

        return `
            <span class="${pillClass}">
                ${this.formatSurveyValue(
            value
        )}
            </span>
        `;
    }


    private openCompletedSurvey(
        survey:
            CabHubCompletedSurveyRow
    ): void {

        const satisfaction =
            this.tableRenderer
                .renderDisplay(
                    survey.SatisfactionRatingId,
                    TableRenderType.Number,
                    "SatisfactionRating"
                );

        const anticipatedHours =
            this.tableRenderer
                .renderDisplay(
                    survey.AnticipatedHoursNextMonthId,
                    TableRenderType.Number,
                    "YesNoNotSure"
                );

        const trainingNeeded =
            this.tableRenderer
                .renderDisplay(
                    survey.TrainingNeededId,
                    TableRenderType.Number,
                    "YesNoNotSure"
                );

        const consultationTypes =
            this.tableRenderer
                .renderDisplay(
                    survey.ConsultationTypeIds,
                    TableRenderType.PipePathSeparatedIds,
                    survey.SurveyType ===
                        "CAB"
                        ? "CabConsultationType"
                        : "HubConsultationType"
                );

        $("#completed-survey-modal-title")
            .text(
                `${survey.SurveyType} Survey Response`
            );

        $("#completed-survey-modal-context")
            .text(
                `${survey.CabMemberName} | ` +
                `${survey.HubShortName} | ` +
                `${this.getReportingPeriod(
                    survey
                )}`
            );

        $("#completed-survey-detail-container")
            .html(`
                <div class="row">

                    ${this.renderSurveyDetail(
                "Survey Type",
                survey.SurveyType
            )}

                    ${this.renderSurveyDetail(
                "CAB Member",
                survey.CabMemberName
            )}

                    ${this.renderSurveyDetail(
                "Hub",
                survey.HubName
            )}

                    ${this.renderSurveyDetail(
                "Reporting Period",
                this.getReportingPeriod(
                    survey
                )
            )}

                    ${this.renderSurveyDetail(
                "Met This Month",
                this.renderSurveyPill(
                    survey.MetThisMonth
                        ? "Yes"
                        : "No"
                ),
                true
            )}

                    ${this.renderSurveyDetail(
                "Not Met Explanation",
                survey.NotMetExplanation
            )}

                    ${this.renderSurveyDetail(
                "Hours Worked",
                survey.HoursWorked
            )}

                    ${this.renderSurveyDetail(
                "Additional Hours Compensation Rate",
                survey.AdditionalHoursCompensationRate != null &&
                    survey.AdditionalHoursCompensationRate > 0
                    ? `$${survey.AdditionalHoursCompensationRate}/hr`
                    : null
            )}

                    ${this.renderSurveyDetail(
                "Anticipated Hours Next Month",
                anticipatedHours
            )}

                    ${this.renderSurveyDetail(
                "Consultation Types",
                consultationTypes
            )}

                    ${this.renderSurveyDetail(
                "Other Consultation Type",
                survey.OtherConsultationType
            )}

                    ${this.renderSurveyDetail(
                "Work Description",
                survey.WorkDescription
            )}

                    ${this.renderSurveyDetail(
                "Satisfaction",
                satisfaction
            )}

                    ${this.renderSurveyDetail(
                "Satisfaction Explanation",
                survey.SatisfactionExplanation
            )}

                    ${this.renderSurveyDetail(
                "Support Requested",
                this.renderSurveyPill(
                    survey.SupportRequested
                        ? "Yes"
                        : "No"
                ),
                true
            )}

                    ${this.renderSurveyDetail(
                "Support Request Explanation",
                survey.SupportRequestExplanation
            )}

                    ${this.renderSurveyDetail(
                "Training Needed",
                this.renderSurveyPill(
                    trainingNeeded
                ),
                true
            )}

                    ${this.renderSurveyDetail(
                "Training Description",
                survey.TrainingDescription
            )}

                    ${this.renderSurveyDetail(
                "Submitted By",
                survey.SubmittedByName
            )}

                    ${this.renderSurveyDetail(
                "Submitted",
                survey.SubmittedDate
                    ? getDisplayDate(
                        new Date(
                            survey.SubmittedDate
                        )
                    )
                    : null
            )}

                </div>
            `);

        $("#completed-survey-modal")
            .modal(
                "show"
            );
    }


    private renderSurveyDetail(
        label:
            string,
        value:
            any,
        isHtml:
            boolean = false
    ): string {

        const displayValue =
            isHtml
                ? value
                : this.formatSurveyValue(
                    value
                );

        return `
            <div class="col-12 col-md-6 py-3 completed-survey-detail">
                <div class="completed-survey-detail-label">
                    ${label}
                </div>

                <div class="completed-survey-detail-value">
                    ${displayValue}
                </div>
            </div>
        `;
    }
}